import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import Keycloak from 'keycloak-js';

/**
 * Admin guard - checks if user is authenticated
 * You can extend this to check for specific admin roles if needed
 */
export const adminGuard: CanActivateFn = () => {
  const keycloak = inject(Keycloak);
  const router = inject(Router);

  if (!keycloak.authenticated) {
    router.navigate(['/home']);
    return false;
  }

  // Add additional admin role checks here if needed
  // const hasAdminRole = checkAdminRole();
  // if (!hasAdminRole) {
  //   router.navigate(['/forbidden']);
  //   return false;
  // }

  return true;
};
